import { render, staticRenderFns } from "./ArchiveDetailPage.vue?vue&type=template&id=6d4b0916&scoped=true&"
import script from "./ArchiveDetailPage.vue?vue&type=script&lang=js&"
export * from "./ArchiveDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDetailPage.vue?vue&type=style&index=0&id=6d4b0916&scoped=true&lang=css&"
import style1 from "./ArchiveDetailPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b0916",
  null
  
)

export default component.exports